import { axiosInstance } from "@/lib/axios-instance";

interface UploadFileResponse {
  status: string;
  result: {
    _id: string;
    file_type: string;
    file_url: string;
    file_size: string;
  };
}

interface UploadFileFormData {
  file: File;
  file_name: string;
  file_type: string;
  object_ref: string;
  object_ref_value: string;
}

interface ExtractFileFormData {
  file: File;
  file_type: string;
  file_name: string;
}
export const filesApi = {
  uploadFile: async (
    formData: UploadFileFormData,
    companyId: string | undefined,
    pertainsToOpportunity: string
  ): Promise<UploadFileResponse> => {
    const response = await axiosInstance.post(
      `/upload_file_secure?company_id=${companyId}&pertains_to_opportunity=${pertainsToOpportunity}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
  extractFile: async (formData: ExtractFileFormData, companyId: string) => {
    const response = await axiosInstance.post(
      `/extract_file_content?company_id=${companyId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
  anonymizeFile: async (formData: ExtractFileFormData, companyId: string) => {
    const response = await axiosInstance.post(
      `/anonymize_file_content?company_id=${companyId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
  deleteFile: async (
    fileType: string,
    companyId: string,
    opportunity_id: string
  ) => {
    const response = await axiosInstance.delete(
      `/delete_company_file?company_id=${companyId}&opportunity_id=${opportunity_id}&file_type=${encodeURIComponent(fileType)}`
    );
    return response.data;
  },
  deleteExtractedFile: async (fileType: string, companyId: string) => {
    const response = await axiosInstance.get(
      `/delete_extracted_file?fileType=${encodeURIComponent(
        fileType
      )}&company_id=${companyId}`
    );
    return response.data;
  },
};
